import { ReactNode } from 'react';

interface SectionProps {
    title?: string;
    actions?: ReactNode;
    children: ReactNode;
    className?: string;
}

export default function Section({
    title,
    actions,
    children,
    className = '',
}: SectionProps) {
    return (
        <section
            className={`bg-white rounded-lg border border-[#dadbd5] shadow-[0_1px_2px_rgba(28,38,32,0.05)] ${className}`}
        >
            {(title || actions) && (
                <header className="flex items-center justify-between px-6 py-4 border-b border-[#ecede8]">
                    {title && (
                        <h2 className="text-[15px] font-semibold text-[#1c2620]">
                            {title}
                        </h2>
                    )}
                    {actions && (
                        <div className="flex items-center gap-2">{actions}</div>
                    )}
                </header>
            )}
            <div className="p-6">{children}</div>
        </section>
    );
}
